import script from "./Watchers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watchers.vue?vue&type=script&setup=true&lang=ts"

import "./Watchers.vue?vue&type=style&index=0&id=62c34592&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c34592"]])

export default __exports__